<template>
  <div class="page-table scrollable">
    <el-table
      :data="collection"
      :height="tableHeight"
      :row-style="{ 'max-height': '40px' }"
      :default-expand-all="hasExpandCol()"
      @current-change="handleCurrentChange"
      @sort-change="sortChange"
      highlight-current-row
      stripe
      style="width: 100%"
      ref="cTable"
    >
      <div v-for="col in columns" :key="col.name">
        <el-table-column :key="col.name" v-if="col.datatype === 'expand'" type="expand" class-name="subtitle2">
          <template slot="header" slot-scope="scope"> </template>
          <template slot-scope="props">
            <div @mouseover="highlightColumn" @mouseleave="unhighlightColumn">
              <div class="expanded-content">
                <span v-for="(eaCol, idx) in col.columns" :key="idx" class="display-block">
                  <span class="display-inline-block" v-if="eaCol.conditional">
                    <span class="display-inline-block subtitle2 title"> {{ eaCol.label }}: </span>
                    <span class="display-inline-block" v-if="!isEmptyOrNull(props.row, eaCol.name[0])">
                      {{ getObjectPathValue(props.row, eaCol.name[0]) }}
                    </span>
                    <span class="display-inline-block" v-else-if="!isEmptyOrNull(props.row, eaCol.name[1])">
                      {{ getObjectPathValue(props.row, eaCol.name[1]) }}
                    </span>
                  </span>
                  <span v-else>
                    <span v-if="!isEmptyOrNull(props.row, eaCol.name) && eaCol.name === 'sourceBinaryName'">
                      <span class="display-inline-block subtitle2 title"> {{ eaCol.label }}: </span>
                      <span class="display-inline-block"
                        >{{ getObjectPathValue(props.row, eaCol.name) }}
                        <a
                          v-if="!isEmptyOrNull(props.row, 'sourceSha256sum')"
                          :href="
                            `https://www.virustotal.com/gui/file/${getObjectPathValue(
                              props.row,
                              'sourceSha256sum'
                            )}/detection`
                          "
                          target="_blank"
                          rel="noreferrer"
                          >{{ getBinaryHashLabel(props.row, 'sourceSha256sum') }}</a
                        >
                        <span
                          class="display-inline-block icon-copy-to-clipboard cursor-pointer"
                          v-if="!isEmptyOrNull(props.row, 'sourceSha256sum')"
                          @click="copyToClipboard(props.row, 'sourceSha256sum')"
                        >
                        </span>
                      </span>
                    </span>
                    <span v-else-if="!isEmptyOrNull(props.row, eaCol.name) && eaCol.name === 'targetPathName'">
                      <span class="display-inline-block subtitle2 title"> {{ eaCol.label }}: </span>
                      <span class="display-inline-block"
                        >{{ getObjectPathValue(props.row, eaCol.name) }}
                        <a
                          v-if="!isEmptyOrNull(props.row, 'targetSha256sum')"
                          :href="
                            `https://www.virustotal.com/gui/file/${getObjectPathValue(
                              props.row,
                              'targetSha256sum'
                            )}/detection`
                          "
                          target="_blank"
                          rel="noreferrer"
                          >{{ getBinaryHashLabel(props.row, 'targetSha256sum') }}</a
                        >
                        <span
                          class="display-inline-block icon-copy-to-clipboard cursor-pointer"
                          v-if="!isEmptyOrNull(props.row, 'targetSha256sum')"
                          @click="copyToClipboard(props.row, 'targetSha256sum')"
                        >
                        </span>
                      </span>
                    </span>
                    <span v-else>
                      <span class="display-inline-block subtitle2 title" v-if="!isEmptyOrNull(props.row, eaCol.name)">
                        {{ eaCol.label }}:
                      </span>
                      <span class="display-inline-block" v-if="!isEmptyOrNull(props.row, eaCol.name)">
                        {{ getObjectPathValue(props.row, eaCol.name) }}
                      </span>
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-else
          :key="col.name"
          :type="col.datatype"
          :prop="col.name"
          :label="col.label ? col.label : col.name"
          :width="col.width"
          :min-width="col['min-width']"
          class-name="subtitle2"
        >
          <template slot="header" slot-scope="scope"> </template>
          <template slot-scope="scope">
            <div v-if="col.display === 'multicolumn'">
              <div v-for="(eaCol, idx) in col.columns" :key="idx" class="display-block">
                <div
                  class="display-inline-block"
                  v-if="eaCol.datatype === 'datetime' && !isEmptyOrNull(scope.row, eaCol.name)"
                >
                  <span class="display-inline-block title"> {{ eaCol.label }}: </span>
                  <span>
                    <time class="display-inline-block subtitle2 value">{{
                      getFormatedDateTime(scope.row, eaCol)
                    }}</time>
                  </span>
                </div>
                <div class="display-inline-block" v-else-if="eaCol.conditional">
                  <span class="display-inline-block title"> {{ eaCol.label }}: </span>
                  <span class="display-inline-block subtitle2 value">
                    {{ getObjectPathValue(scope.row, eaCol.name[0]) || getObjectPathValue(scope.row, eaCol.name[1]) }}
                  </span>
                </div>
                <div class="display-inline-block" v-else-if="!isEmptyOrNull(scope.row, eaCol.name)">
                  <span class="display-inline-block title" v-if="!$_.isEmpty(eaCol.label)"> {{ eaCol.label }}: </span>
                  <span
                    class="display-inline-block uppercase edgeclass"
                    :class="`event_${getObjectPathValue(scope.row, 'edgeClass').toLowerCase()}`"
                    v-if="eaCol.name === 'edgeName'"
                  >
                    {{ getObjectPathValue(scope.row, 'edgeClass') }}
                  </span>
                  <span class="display-inline-block subtitle2 value">
                    {{ getObjectPathValue(scope.row, eaCol.name) }}
                  </span>
                </div>
              </div>
            </div>

            <div v-else>
              <span class="body1">{{ scope.row[col.name] }}</span>
            </div>
          </template>
        </el-table-column>
      </div>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="this.tableData.recordsPerPage"
      :total="this.tableData.totalRecords"
      :current-page="this.tableData.currentPage"
      prev-text="PREV"
      next-text="NEXT"
      hide-on-single-page
      style="text-align: center; padding-top: 20px;"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { NANOSECONDS_TO_MILLISECONDS } from '@/constants/datetime.constants'
import BasicTableElement from '@/components/table/BasicTableElement.vue'

export default {
  name: 'ExpandedTableElement',
  extends: BasicTableElement,
  props: {
    heightOffset: { default: 0, type: Number },
    columns: { type: Array },
    tableData: { type: Object }
  },
  data () {
    return {
      currentRow: undefined,
      collection: [],
      tableHeight: 'auto'
    }
  },
  methods: {
    hasExpandCol () {
      return _.findIndex(this.columns, { datatype: 'expand' }) > -1
    },
    getHeader (h, { column, $index }) {
      return ''
    },
    isEmptyOrNull (row, colName) {
      return (
        (!_.isNumber(this.getObjectPathValue(row, colName)) &&
          (_.isEmpty(this.getObjectPathValue(row, colName)) ||
            this.getObjectPathValue(row, colName).toLowerCase() === 'null')) ||
        (_.isNumber(this.getObjectPathValue(row, colName)) && this.getObjectPathValue(row, colName) < 0)
      )
    },
    getFormatedDateTime (row, col) {
      let timeVal = this.getObjectPathValue(row, col.name)

      // convert startTime to ms if necessary
      if (timeVal && !moment(timeVal).isValid()) {
        timeVal = timeVal * NANOSECONDS_TO_MILLISECONDS
      }
      return moment(timeVal).format(col.format)
    },
    getBinaryHashLabel (row, hashField) {
      if (row[hashField] && !_.isNull(row[hashField]) && row[hashField].toLowerCase() !== 'null') {
        return `(${row[hashField].substring(0, 12)})`
      }
      return ''
    },
    highlightColumn (event) {
      if (this.hasExpandCol() && event.fromElement) {
        let rowExpandedEl = event.currentTarget
        rowExpandedEl = rowExpandedEl.closest('tr')
        rowExpandedEl.classList.add('hover')
        let mainRowEl = rowExpandedEl.previousElementSibling
        if (mainRowEl) {
          mainRowEl.classList.add('hover')
        }
      }
    },
    unhighlightColumn (event) {
      if (this.hasExpandCol() && event.fromElement) {
        let rowExpandedEl = event.currentTarget
        rowExpandedEl = rowExpandedEl.closest('tr')
        rowExpandedEl.classList.remove('hover')
        let mainRowEl = rowExpandedEl.previousElementSibling
        if (mainRowEl) {
          mainRowEl.classList.remove('hover')
        }
      }
    }
  },
  mounted () {
    this.tableHeight = `${this.$el.parentElement.clientHeight - this.heightOffset - 60}`
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/colors.css';
@import 'assets/styles/tables.css';

>>> .el-table .cell {
  line-height: 16px;
  word-break: break-word;

  .el-table__expand-icon {
    display: none;
  }
}

>>> .el-table__expanded-cell {
  padding: 0px;
  > div {
    padding: 0px;

    .expanded-content {
      padding: 0px 10px;
      padding-bottom: 10px;
    }
  }
}
>>> .el-table__row {
  td {
    padding: 10px 0px 0px 0px;
    border-bottom: none !important;

    .cell {
      div.display-block {
        padding: 2px 0px;
      }
    }
  }
}

>>> .el-table__row--striped.expanded + tr {
  td {
    background: #fafafa;
  }
}

>>> .current-row.expanded + tr {
  td {
    background-color: #ecf5ff;
  }
}

>>> .el-table--enable-row-hover .el-table__body .el-table__row.expanded:hover + tr {
  td {
    background-color: #f5f7fa;
  }
}

>>> .el-table tr.hover {
  background-color: #f5f7fa;
}

>>> .el-table__row--striped.expanded.hover {
  td {
    background-color: #f5f7fa;
  }
}

>>> .el-table tr.current-row.hover {
  background-color: #f5f7fa;
  td {
    background-color: #f5f7fa;
  }
}

>>> .el-table .el-table__row--striped.current-row:hover {
  background-color: #f5f7fa;
  td {
    background-color: #f5f7fa;
  }
}

.subtitle2 {
  line-height: 16px;
}

.title {
  /* width: 115px; */
  background-color: var(--aluminum-300);
}

.title,
.edgeclass {
  font-weight: 600;
  padding: 0px 5px;
  border-radius: 2px;
}

.event_exec {
  background-color: var(--amaranth-50);
}

.event_file {
  background-color: var(--denim-50);
}

.event_network {
  background-color: var(--shamrock-50);
}

.event_system {
  background-color: var(--candlelight-100);
}

.event_user {
  background-color: var(--tuna-300);
}

.icon-copy-to-clipboard {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/table/ExpandedTableElement.vue